export default __webpack_public_path__ + "static/media/default-candidate.cc0c3510.png";